const reviewsList = [
  {
    id: 1,
    image: '1',
    title: 'reviews.name',
    subTitle: 'reviews.manager',
    company: 'Company1',
    reg: 'Регистрация бизнеса1',
    country: 'reviews.countryFirst',
    text: 'reviews.textFirst',
    label: 'reviews.labelFirst',
  },
  {
    id: 2,
    image: '2',
    title: 'reviews.name',
    subTitle: 'reviews.manager',
    icon: 'country',
    company: 'Company2',
    reg: 'Регистрация бизнеса2',
    country: 'reviews.countrySecond',
    text: 'reviews.textSecond',
    label: 'reviews.labelSecond',
  },
  {
    id: 3,
    image: '3',
    title: 'reviews.name',
    subTitle: 'reviews.manager',
    company: 'Company3',
    reg: 'Регистрация бизнеса3',
    country: 'reviews.countryThird',
    text: 'reviews.textThird',
    label: 'reviews.labelThird',
  },
];

export default reviewsList;
